import { render, staticRenderFns } from "./EditTaxModal.vue?vue&type=template&id=7f728c65&"
import script from "./EditTaxModal.vue?vue&type=script&lang=js&"
export * from "./EditTaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports